<template>  
  <div class="card">
    <div class="up">
      <div id="img-container">
        <img v-bind:src="imgUrl" v-on:click="click(residueName, true)"> 
      </div> 

      <input type="checkbox" 
             name="checkbox_residue" 
     v-bind:value="residueName" 
        v-bind:id="'checkbox_residue_'+residueName" 
       v-on:click="click(residueName, false)"
   v-bind:checked="checked" />

    </div>
    <div class="down">
      <a target="_blank" v-bind:href="'https://en.wikipedia.org/wiki/' + residueName" >
          {{ residueName }}
      </a>
      <div class="count"> {{ count }} </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'residueCard', 
  props: ['imgUrl', 'residueName', 'count', 'checked'],   
  methods: {
    click: function (residueName, flag) { 
      if (flag==true) {
        var checkbox = document.getElementById('checkbox_residue_'+residueName) 
        checkbox.checked = !checkbox.checked  
      }
      this.$emit('click_checkbox', 'checkbox_residue')
      // console.log(residueName)
    } 
  } 
}
</script> 
 
<style scoped>  
  .card {
    margin: 1px;
    border: 1px solid black; 
    height: 150px;
    width:  250px; 
    display: flex;
    flex-direction: column;
  }
  .up { 
    display: flex; 
    justify-content: space-between;
    position: relative;
  }
  #img-container { 
    width: 250px;
    height:130px;
    display: flex;
    flex-direction: row; 
    align-items: center;
    justify-content: center;
  }
  img { 
    border: 0px solid black;
    max-width: 248px;
    max-height:128px;
  }  
  input {
    position: absolute;
    left: 105px;
  }
  .down {
    position: relative;
    font-size: 1em;
    font-weight: bold;
    text-align: center;
  }
  .count{
    position: absolute;
    height: 100%;
    bottom: 0;
    right:1%;
  }

  input[type="checkbox"] { 
    zoom: 2;
  } 
</style>
